import React from 'react';

export function UnderPriceIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='10' cy='10' r='9' stroke='currentColor' strokeWidth='2' />
      <circle cx='10' cy='10' r='9' stroke='currentColor' strokeOpacity='0.2' strokeWidth='2' />
      <path
        d='M10 6V14M6 10L10 14L14 10'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 6V14M6 10L10 14L14 10'
        stroke='currentColor'
        strokeOpacity='0.2'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
